/**
 * visibility.ts — traduzione dei modi di visibilita' in stato di componente.
 *
 * Sta al livello pubblico (accanto a LockScene.types.ts) e non in `config/`
 * perche' il barrel non espone gli interni di config: il consumatore sceglie
 * un modo, l'opacita' concreta resta decisa da BEAM_OPACITY qui dentro.*/

import { BEAM_OPACITY } from "./config/defaults";
import type { BeamVisibility, ComponentDisplayState } from "./LockScene.types";

/** Stato di una trave a partire dal modo scelto nel menu del viewer.*/
export function beamDisplayState(mode: BeamVisibility): ComponentDisplayState {
  return {
    visible: mode !== "hidden",
    opacity: mode === "solid" ? 1 : BEAM_OPACITY,
  };
}
